import React, { useState, useRef, useEffect } from 'react';
import { useLocation, useNavigate } from '@reach/router';
import qs from 'query-string';

import isBrowser from '~/utils/is-browser';
import apiCall, { TEST_URL, LIVE_URL } from '~/utils/apiCall';
import copy from '~/utils/copy-text';
import dabangBridge from '~/utils/bridge';
import ga from '~/utils/ga';
import isMobile from '~/utils/is-mobile';
import isEmpty from '~/utils/valid/is-empty';

// import useAuth from '~/hooks/useAuth';

import top from './images/top.png';
import agree_off from './images/agree_off.png';
import agree_on from './images/agree_on.png';
import terms from './images/terms.png';
import score from './images/score.png';
import quiz from './images/quiz.png';
import buttons from './images/buttons.png';
import kakao from './images/kakao.png';
import url_copy from './images/url_copy.png';
import bottom from './images/bottom.png';
import notice from './images/notice.png';

import {
  BGWrap,
  AgreeWrap,
  ScoreImg, CountWrap, QuizImg,
  ImgBtn, OXBtn,
  TestWrap,
} from './styled';

const items = [
  '0',
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
];

const isDev = process.env.NODE_ENV === 'development';
const DABANG_LOGIN = 'https://dabangapp.com/login';
const DABANG_TEST_LOGIN = 'https://test-dabang-web.dabangapp.com/login';
const HOST = process.env.NODE_ENV === 'development' ? TEST_URL : LIVE_URL;

function SignEvent() {
  const [agree, setAgree] = useState(false);
  const [isSending, setSending] = useState(false);
  const [state, setState] = useState({
    answered: false,
    point: 0,
    printPoint: '000',
    quiz: '',
    url: '',
  });
  const _slots = useRef([]);

  const location = useLocation();
  const navigate = useNavigate();
  const { pathname, search } = location;

  const parse = qs.parse(search);
  const authKey = parse?.auth_key || isBrowser() && sessionStorage.getItem('authKey') || '';
  delete parse.auth_key;

  const isM = isMobile.any();

  useEffect(() => {
    if (!window.Kakao.isInitialized()) window.Kakao.init('7b905539e95a55efabd3ba6320ba6bae');

    getQuiz(authKey);
    navigate(isEmpty(parse) ? pathname : pathname + `?${qs.stringify(parse)}`, { replace: true });

    if (isBrowser()) {
      sessionStorage.clear();
      sessionStorage.setItem('authKey', authKey);
    }
  }, []);

  useEffect(() => {
    spin();
  }, [state.printPoint, _slots]);

  function init({ firstInit = true, groups = 1, duration = 1, slots = [], point = state.printPoint }) {
    for (let i = 0; i < slots.length; i++) {
      const slot = slots[i];

      if (firstInit) {
        slot.dataset.spinned = '0';
      } else if (slot?.dataset?.spinned === '1') {
        return;
      }

      const boxes = slot?.querySelector('.boxes');
      const boxesClone = boxes?.cloneNode(false);
      const pool = ['0'];

      if (!firstInit) {
        const arr = [];
        for (let n = 0; n < (groups > 0 ? groups : 1); n++) {
          arr.push(...items);
        }

        pool.push(...shuffle(arr), point[i]);
      }

      for (let i = pool.length - 1; i >= 0; i--) {
        const box = document.createElement('div');
        box.classList.add('box');
        box.textContent = pool[i];
        box.style.textAlign = 'center';
        box && boxesClone && boxesClone.appendChild(box);
      }

      if (boxesClone) {
        boxesClone.style.transitionDuration = `${duration > 0 ? duration : 1}s`;
        boxesClone.style.transform = `translateY(-${slot.clientHeight * (pool.length - 1)}px)`;
        slot.replaceChild(boxesClone, boxes);
      }
    }
  }

  async function spin(point) {
    init({ firstInit: false, groups: 1, duration: 2, slots: _slots.current, point });

    for (let i = 0; i < _slots.current.length; i++) {
      const slot = _slots.current[i];
      const boxes = slot?.querySelector('.boxes');
      const isWhite = state.point === 0 ? [] : state.point > 0 && state.point < 10 ? [2] : state.point < 100 ? [1, 2] : [0, 1, 2];

      if (boxes) {
        const duration = parseInt(boxes.style.transitionDuration);
        boxes.style.transform = 'translateY(0)';

        await new Promise((resolve) => setTimeout(resolve, duration * 100));

        const box = boxes.querySelector('.box');

        if (isWhite.includes(i)) box.style.color = 'white';
      }
    }
  }

  function shuffle([...arr]) {
    let m = arr.length;

    while (m) {
      const i = Math.floor(Math.random() * m--);
      [arr[m], arr[i]] = [arr[i], arr[m]];
    }

    arr.push()

    return arr;
  }

  async function getQuiz(authKey) {
    try {
      const res = await apiCall.get(`${HOST}/api/v1/event/sign-quiz`, { authKey });
      const printPoint = res.result.point < 10 ? `00${res.result.point}` : res.result.point < 100 ? `0${res.result.point}` : '100';

      setState({
        ...res.result,
        printPoint,
      });
    } catch(err) {
      console.log(err);
    }
  }

  async function submit(answer = 'O', authKey) {
    // 모바일 웹 설치 유도
    if (dabangBridge.getPlatform() === 'web' && isM) {
      return window.location.href = 'https://dabang.page.link/9Vrq';
    }

    if (isSending) return;
    if (!agree) return alert('본 이벤트는 정보입력 및 개인정보 수집/이용 항목에 동의 후 참여가능 합니다.');

    setSending(true);

    ga('22-07_다방싸인_OX퀴즈', 'OX참여', answer === 'O' ? 'O선택' : 'X선택');

    try {
      const res = await apiCall.post(`${HOST}/api/v1/event/sign-quiz`, {
        authKey,
        quizName: state.quiz,
        answer,
      });

      const { code, result, msg } = res;

      if (code === 200) {
        alert(state.quiz === 'q20' ? '퀴즈에 참여 완료 하셨습니다!\n최종 점수를 확인해주세요!' : 'OX퀴즈에 참여완료 하셨습니다!\n00시에 오픈하는 다음퀴즈에도 도전하세요!');
        const printPoint = res.result.point < 10 ? `00${res.result.point}` : res.result.point < 100 ? `0${res.result.point}` : '100';

        setState(prev => ({
          ...prev,
          ...result,
          printPoint,
        }));

      } else if (code === 502 || code === 508) {
        alert(msg ?? '서버에러가 발생했습니다.');

        dabangBridge.ios(call => {
          call.callHandler('ObjC Echo', {
            cmd: 'showAuthAndReload',
          });
        });
    
        dabangBridge.android(call => {
          call.showAuthAndReload();
        });
  
        dabangBridge.web(() => {
          return window.open('https://dabangapp.com/account/edit', '_blank');
        });

      } else if (code === 501) {
        alert(msg ?? '서버에러가 발생했습니다.');

        dabangBridge.ios(call => {
          call.callHandler('ObjC Echo', {
            cmd: 'showLoginAndReload',
          });
        });
    
        dabangBridge.android(call => {
          call.showLoginAndReload();
        });
    
        dabangBridge.web(call => {
          return window.location.href = isDev ? DABANG_TEST_LOGIN : DABANG_LOGIN;
        });

      } else {
        alert(msg ?? '서버에러가 발생했습니다.');
      }

      setSending(false);

    } catch(err) {
      console.log(err);
      alert(err?.msg ?? '서버에러가 발생했습니다.');
    }
  }

  function clickKaKaoShare() {
    window.Kakao.Link.sendDefault({
      callback: () => {
        ga('22-07_다방싸인_OX퀴즈', '공유하기', '카카오톡 공유');
      },
      objectType: 'feed',
      content: {
        title: '다방싸인 OX퀴즈',
        imageUrl: `https://static.dabangapp.com/img/event/sign_ox/42d61a9c-78d8-4d82-b714-435ca45f280b.png?_=${new Date().valueOf()}`,
        link: {
          webUrl: window.location.href,
          mobileWebUrl: window.location.href,
        },
        description: '다방싸인 OX 퀴즈 풀고! 푸짐한 경품을 잡아라!',
      },
      installTalk: true,
    });
  }

  function clickCopy() {
    ga('22-07_다방싸인_OX퀴즈', '공유하기', 'URL 복사');
    alert('URL이 복사되었습니다.');
    copy(window.location.href);
  }

  function clickSignBanner() {
    ga('22-07_다방싸인_OX퀴즈', '다방싸인 소개보기', '소개페이지');

    const url = 'https://master.dt57cx1j6t39u.amplifyapp.com/2022/01/dabang-banner/';

    dabangBridge.web(() => {
      window.location.href = url;
    });

    dabangBridge.ios(call => {
      call.callHandler('ObjC Echo', {
        cmd: 'openInAppBrowser',
        url: url,
      });
    });

    dabangBridge.android(call => {
      call.openInAppBrowser(url);
    });
  }

  async function clickTestReset() {
    try {
      await apiCall.get(`${HOST}/api/v1/event/sign-quiz/reset/test`, { authKey });
      const res = await apiCall.get(`${HOST}/api/v1/event/sign-quiz/test`, { authKey, quizName: 'q1' });

      setState(prev => ({
        ...prev,
        ...res.result,
        point: 0,
        printPoint: '000',
      }));

      alert('리셋 완료');
    } catch(err) {
      console.log(err);
    }
  }

  async function getTestQuiz(e) {
    const { value } = e.currentTarget;

    try {
      const res = await apiCall.get(`${HOST}/api/v1/event/sign-quiz/test`, { authKey, quizName: value });
      const printPoint = res.result.point < 10 ? `00${res.result.point}` : res.result.point < 100 ? `0${res.result.point}` : '100';

      setState({
        ...res.result,
        printPoint,
      });

    } catch(err) {
      console.log(err);
    }
  }

  return (
    <>
      <BGWrap imgUrl={top} width={710} height={1920} />

      <BGWrap imgUrl={agree ? agree_on : agree_off} width={710} height={41} style={{ top: '-1px' }}>
        <AgreeWrap onClick={() => setAgree(prev => !prev)} />
      </BGWrap>

      {agree && <BGWrap imgUrl={terms} width={710} height={190} style={{ top: '-2px' }} />}

      <BGWrap imgUrl={quiz} width={710} height={827} style={{ top: '-3px' }}>
        <ScoreImg>
          <BGWrap imgUrl={score} width={668} height={178} />
          <CountWrap>
            <div style={{ display: 'flex' }}>
              {state.printPoint?.length > 0 && state.printPoint.split('').map((_, idx) => (
                <div key={idx} ref={el => (_slots.current[idx] = el)} style={{ height: '100%', overflow: 'hidden' }}>
                  <div className="boxes">0</div>
                </div>
              ))}
            </div>
          </CountWrap>
        </ScoreImg>

        <QuizImg src={`${state.url}?_=${new Date().valueOf()}`} alt="quiz" />
        {!state.answered && (
          <>
            <OXBtn className="O" onClick={() => submit('O', authKey)} />
            <OXBtn className="X" onClick={() => submit('X', authKey)} />
          </>
        )}
      </BGWrap>

      {/* <TestWrap>
        <select value={state.quiz} onChange={getTestQuiz.bind(null)}>
          <option value="q1">1</option>
          <option value="q2">2</option>
          <option value="q3">3</option>
          <option value="q4">4</option>
          <option value="q5">5</option>
          <option value="q6">6</option>
          <option value="q7">7</option>
          <option value="q8">8</option>
          <option value="q9">9</option>
          <option value="q10">10</option>
          <option value="q11">11</option>
          <option value="q12">12</option>
          <option value="q13">13</option>
          <option value="q14">14</option>
          <option value="q15">15</option>
          <option value="q16">16</option>
          <option value="q17">17</option>
          <option value="q18">18</option>
          <option value="q19">19</option>
          <option value="q20">20</option>
        </select>

        <button onClick={clickTestReset}>reset</button>
      </TestWrap> */}

      <BGWrap imgUrl={buttons} width={710} height={141} style={{ top: '-4px' }}>
        <ImgBtn className="kakao" src={kakao} alt="kakao" onClick={clickKaKaoShare} />
        <ImgBtn className="url_copy" src={url_copy} alt="url_copy" onClick={clickCopy} />
      </BGWrap>

      <BGWrap imgUrl={bottom} width={710} height={243} style={{ top: '-5px' }}>
        <button className="around" onClick={clickSignBanner} />
      </BGWrap>

      <BGWrap imgUrl={notice} width={710} height={874} style={{ top: '-6px' }} />
    </>
  );
}

export default SignEvent;
